import { Box, Grid, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import {
  AD_ACCOUNT_OPTIONS_DISPLAY_NAMES,
  Platforms,
} from "../../../../../../utils/constants";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { icons } from "../../../icons/iconExport";
import { ServerTypeIconsAndLabels } from "../../../utils";
import {
  getMacOSName,
  getWindowsOSName,
} from "../../entitiesCharts/hostChart/osVersionDistribution/osVersionHelpers";

import TextIntegrationStyle from "../../TextIntegrationStyle";

import AzureVirtualMachineDetailsView from "./AzureVirtualMachineDetailsView";

const ServerDetailsView = ({ entityData }) => {
  const typeLogoAws = (type) => {
    if (Object.keys(ServerTypeIconsAndLabels).includes(type)) {
      const [icon] = ServerTypeIconsAndLabels[type];
      return icon;
    }
    return null;
  };

  const akamaiData = [
    [entityData?.akamai_waf_data?.group_name, "Group Name", icons.groupsIcon],
    [
      entityData?.akamai_waf_data?.configuration_name,
      "Configuration Name",
      icons.rolesIcon,
    ],
    [
      entityData?.akamai_waf_data?.property_name,
      "Property Name",
      icons.propertiesIcon,
    ],
    [
      entityData?.akamai_waf_data?.deployed_network,
      "Deployed Network",
      icons.internetFacingIcon,
    ],
    [
      entityData?.akamai_waf_data?.deployment,
      "Deployment Status",
      icons.siteIcon,
    ],
    [
      entityData?.akamai_waf_data?.certificate_expiration,
      "Certificate Expiration",
      icons.mfaIcon,
    ],
  ];

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2} mb={4}>
      {(entityData?.crowdstrike_data?.server_name ||
        entityData?.paloalto_cortex_xdr_data?.name ||
        entityData?.microsoft_sccm_data?.name ||
        entityData?.microsoft_defender_data?.server_name ||
        entityData?.microsoft_active_directory_data?.name) && (
        <Box display={"flex"} gap={1} alignItems={"center"}>
          <Typography variant="subtitle2" fontWeight="500">
            Server Name
          </Typography>
        </Box>
      )}
      <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
        {entityData?.crowdstrike_data?.server_name && (
          <>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"crowdstrike"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.crowdstrike_data?.server_name}
            />
          </>
        )}
        {entityData?.paloalto_cortex_xdr_data?.name && (
          <>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"paloalto_cortex_xdr"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.paloalto_cortex_xdr_data?.name}
            />
          </>
        )}
        {entityData?.microsoft_sccm_data?.name && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"microsoft_sccm"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.microsoft_sccm_data?.name}
          />
        )}
        {entityData?.microsoft_defender_data?.server_name && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"microsoft_defender_endpoint"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.microsoft_defender_data?.server_name}
          />
        )}
        {entityData?.microsoft_active_directory_data?.name && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"microsoft_active_directory"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.microsoft_active_directory_data?.name}
          />
        )}
      </Box>
      {(entityData?.microsoft_active_directory_data?.organizational_unit ||
        entityData?.crowdstrike_data?.organization_unit) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Organizational Unit</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
            {entityData?.microsoft_active_directory_data
              ?.organizational_unit && (
              <TextIntegrationStyle
                title={""}
                value={
                  entityData?.microsoft_active_directory_data
                    ?.organizational_unit
                }
              ></TextIntegrationStyle>
            )}
            {entityData?.crowdstrike_data?.organization_unit && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"crowdstrike"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.crowdstrike_data?.organization_unit}
              />
            )}
          </Box>
        </Box>
      )}
      {entityData?.azure_vm_data && (
        <AzureVirtualMachineDetailsView entityData={entityData} />
      )}
      {(entityData?.cloudflare_data?.account_name ||
        entityData?.aws_data?.account_nickname ||
        entityData?.imperva_waf_data?.account_plan) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Account Name</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            {entityData?.cloudflare_data?.account_name && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"cloudflare"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.cloudflare_data?.account_name}
              ></TextIntegrationStyle>
            )}
            {entityData?.aws_data?.account_nickname && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"aws"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.aws_data?.account_nickname}
              ></TextIntegrationStyle>
            )}
            {entityData?.azure_vm_data?.subscription_name && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"azure"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.azure_vm_data?.subscription_name}
              ></TextIntegrationStyle>
            )}
            {entityData?.imperva_waf_data?.account_plan && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"imperva_waf"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.imperva_waf_data?.account_plan}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}
      {entityData?.platform && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Platform</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle title={""} value={entityData?.platform} />
          </Box>
        </Box>
      )}

      {(entityData?.os_version && entityData.os_version !== "None") ||
      entityData?.rapid7_insight_vm_data?.os_version ||
      entityData?.paloalto_cortex_xdr_data?.os_version ||
      entityData?.microsoft_sccm_data?.os_version ||
      entityData?.microsoft_active_directory_data?.operating_system_version ? (
        <>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>OS Version</Typography>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
              {entityData?.os_version && entityData.os_version !== "None" && (
                <Box ml={-1} display={"flex"}>
                  <TextIntegrationStyle
                    title={""}
                    value={
                      entityData?.platform === Platforms.WINDOWS
                        ? getWindowsOSName(entityData?.os_version)
                        : entityData?.platform === Platforms.MACOS
                        ? getMacOSName(entityData?.os_version)
                        : entityData?.os_version
                    }
                  ></TextIntegrationStyle>
                </Box>
              )}
              {entityData?.rapid7_insight_vm_data?.os_version && (
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"rapid7_insight_vm"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={entityData?.rapid7_insight_vm_data?.os_version}
                />
              )}
              {entityData?.paloalto_cortex_xdr_data?.os_version && (
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"paloalto_cortex_xdr"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={entityData?.paloalto_cortex_xdr_data?.os_version}
                />
              )}
              {entityData?.microsoft_sccm_data?.os_version && (
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"microsoft_sccm"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={entityData?.microsoft_sccm_data?.os_version}
                />
              )}
              {entityData?.microsoft_active_directory_data
                ?.operating_system && (
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"microsoft_active_directory"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={
                    entityData?.microsoft_active_directory_data
                      ?.operating_system
                  }
                />
              )}
            </Box>
          </Box>
          {entityData?.os_version && entityData.os_version !== "None" && (
            <Box display={"flex"} flexDirection={"column"} gap={1}>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <Typography variant={"subtitle2"}>OS Build</Typography>
              </Box>
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.os_version}
                ></TextIntegrationStyle>
              </Box>
            </Box>
          )}
        </>
      ) : null}

      {(entityData?.cloudflare_data?.account_id ||
        entityData?.aws_data?.account_id ||
        entityData?.imperva_waf_data?.account_id) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Account ID</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            {entityData?.cloudflare_data?.account_id && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"cloudflare"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.cloudflare_data?.account_id}
              ></TextIntegrationStyle>
            )}
            {entityData?.aws_data?.account_id && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"aws"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.aws_data?.account_id}
              ></TextIntegrationStyle>
            )}
            {entityData?.imperva_waf_data?.account_id && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"imperva_waf"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.imperva_waf_data?.account_id}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}

      {entityData?.aws_data?.org && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Organization</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            {entityData?.aws_data?.org && (
              <IntegrationImage name={"aws"} width={"30px"} />
            )}
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_data?.org}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {entityData?.cloudflare_data?.phishing_detected != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Phishing Detected</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.cloudflare_data?.phishing_detected ? "Yes" : "No"
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {(entityData?.cloudflare_data?.server_type ||
        entityData?.aws_service) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Type</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            {entityData?.cloudflare_data?.server_type && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage name={"cloudflare"} width={"24px"} />
                  </Box>
                }
                value={entityData?.cloudflare_data?.server_type}
              ></TextIntegrationStyle>
            )}
            {entityData?.aws_service && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    {typeLogoAws(entityData?.aws_service) ? (
                      <SvgToIcon
                        IconLogo={typeLogoAws(entityData?.aws_service)}
                        width={"16px"}
                      />
                    ) : (
                      <IntegrationImage name={"aws"} width={"24px"} />
                    )}
                  </Box>
                }
                value={entityData?.aws_service}
              ></TextIntegrationStyle>
            )}{" "}
          </Box>
        </Box>
      )}
      {entityData?.aws_data?.image_description && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Image</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_data?.image_description}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {entityData?.aws_data?.region && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Region</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_data?.region}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.aws_data?.resource_arn && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>ARN</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <Grid container gap={2} direction={"row"}>
              <Grid item xs={7}>
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.aws_data?.resource_arn}
                ></TextIntegrationStyle>
              </Grid>
              <Grid item xs={3}>
                <CustomCopyButton
                  copyTitle={"ARN"}
                  copyText={entityData?.aws_data?.resource_arn}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      {entityData?.akamai_waf_data && (
        <Box display="flex" flexDirection="column" gap={1}>
          {akamaiData.map((propData, index) => {
            const value = propData[0];
            const title = propData[1];
            const icon = propData[2];
            if (!value) return null;
            return (
              <Box key={index}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={1}
                >
                  <SvgToIcon IconLogo={icon} width="16px" />
                  <Typography variant="subtitle2">{title}</Typography>
                </Box>
                <Box ml={2} display="flex">
                  <TextIntegrationStyle title="" value={value} />
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
      {entityData?.microsoft_sccm_data && (
        <Box display="flex" flexDirection="column" gap={1}>
          {[
            [
              entityData?.microsoft_sccm_data?.os_name,
              "OS Name",
              icons.serverTypeIcon,
            ],
            [
              entityData?.microsoft_sccm_data?.serial_number,
              "Serial Number",
              icons.serialNumberIcon,
            ],
          ].map((propData, index) => {
            const value = propData[0];
            const title = propData[1];
            const icon = propData[2];
            if (!value) return null;
            return (
              <Box key={`sccm-${index}`}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={1}
                >
                  <SvgToIcon IconLogo={icon} width="16px" />
                  <Typography variant="subtitle2">{title}</Typography>
                </Box>
                <Box ml={2} display="flex">
                  <TextIntegrationStyle
                    title={
                      <Box display={"flex"}>
                        <IntegrationImage
                          name={"microsoft_sccm"}
                          width={"16px"}
                          newLogo={true}
                        />
                      </Box>
                    }
                    value={value}
                  />
                </Box>
              </Box>
            );
          })}
        </Box>
      )}

      {entityData?.aws_data?.cluster_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Cluster</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_data?.cluster_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.aws_data?.instance_id && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Instance ID</Typography>
          </Box>
          <Box ml={2} gap={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_data?.instance_id}
            ></TextIntegrationStyle>
            <CustomCopyButton
              copyTitle={"Instance ID"}
              copyText={entityData?.aws_data?.instance_id}
            />
          </Box>
        </Box>
      )}
      {(entityData?.aws_data?.public_ip ||
        entityData?.aws_data?.private_ip ||
        entityData?.crowdstrike_data?.external_ip ||
        entityData?.crowdstrike_data?.internal_ip ||
        entityData?.sentinel_one_server?.external_ip ||
        entityData?.paloalto_cortex_xdr_data?.public_ip ||
        (entityData?.azure_vm_data?.public_ips &&
          entityData.azure_vm_data.public_ips.length > 0) ||
        (entityData?.azure_vm_data?.private_ips &&
          entityData.azure_vm_data.private_ips.length > 0) ||
        entityData?.qualys_data?.external_ip_address ||
        entityData?.qualys_data?.internal_ip_address ||
        entityData?.servicenow_cmdb_data?.ip_address ||
        entityData?.microsoft_defender_data?.external_ip_address ||
        entityData?.microsoft_defender_data?.internal_ip_address ||
        (entityData?.imperva_waf_data?.ip_addresses &&
          entityData.imperva_waf_data.ip_addresses.length > 0)) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>IP Address</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
            {entityData?.aws_data?.public_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"aws"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.aws_data?.public_ip + " (External)"}
              />
            )}
            {entityData?.aws_data?.private_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"aws"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.aws_data?.private_ip + " (Internal)"}
              />
            )}
            {entityData?.crowdstrike_data?.external_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"crowdstrike"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.crowdstrike_data?.external_ip + " (External)"
                }
              />
            )}
            {entityData?.crowdstrike_data?.internal_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"crowdstrike"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.crowdstrike_data?.internal_ip + " (Internal)"
                }
              />
            )}
            {entityData?.sentinel_one_server?.external_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"sentinel_one"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.sentinel_one_server?.external_ip + " (External)"
                }
              />
            )}
            {entityData?.paloalto_cortex_xdr_data?.public_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"paloalto_cortex_xdr"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.paloalto_cortex_xdr_data?.public_ip}
              />
            )}
            {entityData?.azure_vm_data?.public_ips &&
              entityData?.azure_vm_data?.public_ips.length > 0 && (
                <Box display="flex" flexDirection="column" gap={1}>
                  {entityData?.azure_vm_data?.public_ips.map(
                    (public_ip_info) => (
                      <TextIntegrationStyle
                        title={
                          <Box display="flex">
                            <IntegrationImage
                              name={"azure"}
                              width="16px"
                              newLogo={true}
                            />
                          </Box>
                        }
                        value={[
                          public_ip_info.ip_address,
                          public_ip_info?.fqdn,
                          "(External)",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      />
                    )
                  )}
                </Box>
              )}
            {entityData?.azure_vm_data?.private_ips &&
              entityData?.azure_vm_data?.private_ips.length > 0 && (
                <TextIntegrationStyle
                  title={
                    <Box display="flex">
                      <IntegrationImage
                        name={"azure"}
                        width="16px"
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={`${entityData?.azure_vm_data.private_ips.join(
                    ", "
                  )} (Internal)`}
                />
              )}
            {entityData?.qualys_data?.external_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"qualys"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.qualys_data?.external_ip_address + " (External)"
                }
              />
            )}
            {entityData?.qualys_data?.internal_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"qualys"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.qualys_data?.internal_ip_address + " (Internal)"
                }
              />
            )}
            {entityData?.servicenow_cmdb_data?.ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"servicenow_cmdb"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.servicenow_cmdb_data?.ip_address}
              />
            )}
            {entityData?.microsoft_defender_data?.external_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_defender_endpoint"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.microsoft_defender_data?.external_ip_address +
                  " (External)"
                }
              />
            )}
            {entityData?.microsoft_defender_data?.internal_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_defender_endpoint"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.microsoft_defender_data?.internal_ip_address +
                  " (Internal)"
                }
              />
            )}
            {entityData?.imperva_waf_data?.ip_addresses &&
              entityData?.imperva_waf_data?.ip_addresses.length > 0 && (
                <Box display="flex" flexDirection="column" gap={1}>
                  {entityData?.imperva_waf_data?.ip_addresses.map(
                    (ip_address) => (
                      <TextIntegrationStyle
                        key={ip_address}
                        title={
                          <Box display="flex">
                            <IntegrationImage
                              name={"imperva_waf"}
                              width="16px"
                              newLogo={true}
                            />
                          </Box>
                        }
                        value={ip_address}
                      />
                    )
                  )}
                </Box>
              )}
          </Box>
        </Box>
      )}
      {entityData?.is_internet_facing != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Internet Facing</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.is_internet_facing ? "Yes" : "No"}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {(entityData?.aws_data?.open_security_groups?.length > 0 ||
        entityData?.azure_vm_data?.open_security_groups_list?.length > 0) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>
              Network Security Groups
            </Typography>
          </Box>
          {entityData?.aws_data?.open_security_groups?.map((securityGroup) => (
            <Box key={securityGroup} ml={2} display={"flex"}>
              <TextIntegrationStyle
                title={""}
                value={securityGroup}
              ></TextIntegrationStyle>
            </Box>
          ))}
          {entityData?.azure_vm_data?.open_security_groups_list?.map(
            (securityGroup) => (
              <Box key={securityGroup} ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={""}
                  value={securityGroup}
                ></TextIntegrationStyle>
              </Box>
            )
          )}
        </Box>
      )}
      {(entityData?.aws_data?.server_state ||
        entityData?.azure_vm_data?.power_state ||
        entityData?.cloudflare_data?.status ||
        entityData?.microsoft_active_directory_data?.status) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>
              Status During Last Scan
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
            {entityData?.aws_data?.server_state && (
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.aws_data?.server_state}
                ></TextIntegrationStyle>
              </Box>
            )}
            {entityData?.azure_vm_data?.power_state && (
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.azure_vm_data?.power_state}
                ></TextIntegrationStyle>
              </Box>
            )}
            {entityData?.cloudflare_data?.status && (
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={"cloudflare"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={
                    entityData?.cloudflare_data?.is_paused
                      ? "Paused"
                      : `${entityData?.cloudflare_data?.status
                          ?.charAt(0)
                          .toUpperCase()}${entityData?.cloudflare_data?.status?.slice(
                          1
                        )}`
                  }
                ></TextIntegrationStyle>
              </Box>
            )}
            {entityData?.microsoft_active_directory_data?.status && (
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"microsoft_active_directory"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={entityData?.microsoft_active_directory_data?.status}
                />
              </Box>
            )}
            {entityData?.imperva_waf_data?.status && (
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={"imperva_waf"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={entityData?.imperva_waf_data?.status}
                ></TextIntegrationStyle>
              </Box>
            )}
          </Box>
        </Box>
      )}
      {entityData?.aws_data?.imds_version && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>IMDS version</Typography>
          </Box>

          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_data?.imds_version}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.imperva_waf_data && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          {entityData?.imperva_waf_data?.site_status && (
            <Box>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <IntegrationImage
                  name={"imperva_waf"}
                  width={"16px"}
                  newLogo={true}
                />
                <Typography variant={"subtitle2"}>Website Status</Typography>
              </Box>
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.imperva_waf_data?.site_status}
                ></TextIntegrationStyle>
              </Box>
            </Box>
          )}
          {entityData?.imperva_waf_data?.cname && (
            <Box>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <IntegrationImage
                  name={"imperva_waf"}
                  width={"16px"}
                  newLogo={true}
                />
                <Typography variant={"subtitle2"}>CNAME Record</Typography>
              </Box>
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.imperva_waf_data?.cname}
                ></TextIntegrationStyle>
              </Box>
            </Box>
          )}
          {entityData?.imperva_waf_data?.region && (
            <Box>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <IntegrationImage
                  name={"imperva_waf"}
                  width={"16px"}
                  newLogo={true}
                />
                <Typography variant={"subtitle2"}>
                  Data Storage Region
                </Typography>
              </Box>
              <Box ml={2} display={"flex"}>
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.imperva_waf_data?.region}
                ></TextIntegrationStyle>
              </Box>
            </Box>
          )}
        </Box>
      )}
      {entityData?.aws_workspace_machine_data?.user_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>User Name</Typography>
          </Box>

          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_workspace_machine_data?.user_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.aws_workspace_machine_data?.compute_type_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Compute Type</Typography>
          </Box>

          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_workspace_machine_data?.compute_type_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.aws_workspace_machine_data?.running_mode && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Running Mode</Typography>
          </Box>

          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_workspace_machine_data?.running_mode}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.aws_workspace_machine_data?.auto_stop_timeout_in_minutes && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Auto Stop Timeout</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.aws_workspace_machine_data
                  ?.auto_stop_timeout_in_minutes + " minutes"
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.sentinel_one_server?.site_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Site Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.sentinel_one_server?.site_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.sentinel_one_server?.group_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Group Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.sentinel_one_server?.group_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {(entityData?.crowdstrike_data?.machine_domain ||
        entityData?.paloalto_cortex_xdr_data?.domain ||
        entityData?.microsoft_active_directory_data?.distinguished_name) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Machine Domain</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3} flexDirection={"column"}>
            {entityData?.crowdstrike_data?.machine_domain && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"crowdstrike"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.crowdstrike_data?.machine_domain}
              />
            )}
            {entityData?.paloalto_cortex_xdr_data?.domain && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"paloalto_cortex_xdr"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.paloalto_cortex_xdr_data?.domain}
              />
            )}
            {entityData?.microsoft_active_directory_data
              ?.distinguished_name && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_active_directory"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.microsoft_active_directory_data?.distinguished_name
                  .split(",")
                  .filter((part) => part.startsWith("DC="))
                  .map((part) => part.replace("DC=", ""))
                  .join(".")}
              />
            )}
          </Box>
        </Box>
      )}
      {(entityData?.cloudconnexa_open_vpn_data?.domain ||
        entityData?.servicenow_cmdb_data?.domain) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}> Domain </Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            {entityData?.cloudconnexa_open_vpn_data?.domain && (
              <TextIntegrationStyle
                title={""}
                value={entityData?.cloudconnexa_open_vpn_data?.domain}
              ></TextIntegrationStyle>
            )}
            {entityData?.servicenow_cmdb_data?.domain && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"servicenow_cmdb"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.servicenow_cmdb_data?.domain}
              />
            )}
          </Box>
        </Box>
      )}
      {entityData?.cloudconnexa_open_vpn_data?.internet_access && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Split Tunnel Status</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.cloudconnexa_open_vpn_data?.internet_access}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {entityData?.cloudconnexa_open_vpn_data?.connectors_info &&
        entityData?.cloudconnexa_open_vpn_data?.connectors_info.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}> Connectors </Typography>
            </Box>
            <Box ml={2} display={"flex"}>
              {entityData?.cloudconnexa_open_vpn_data?.connectors_info.map(
                (connector) => (
                  <TextIntegrationStyle
                    title={""}
                    value={`name: ${connector.name}, VPN Region ID: ${connector.vpn_region_id}`}
                  ></TextIntegrationStyle>
                )
              )}
            </Box>
          </Box>
        )}
      {entityData?.cloudconnexa_open_vpn_data?.gateways_ids &&
        entityData?.cloudconnexa_open_vpn_data?.gateways_ids.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}> Gateways </Typography>
            </Box>
            <Box ml={2} display={"flex"}>
              {entityData?.cloudconnexa_open_vpn_data?.gateways_ids.map(
                (gateway) => (
                  <TextIntegrationStyle
                    title={""}
                    value={gateway}
                  ></TextIntegrationStyle>
                )
              )}
            </Box>
          </Box>
        )}

      {((entityData?.paloalto_cortex_xdr_data?.local_users &&
        entityData.paloalto_cortex_xdr_data.local_users.length > 0) ||
        (entityData?.qualys_data?.local_admin_users &&
          entityData?.qualys_data?.local_admin_users)) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Local Users</Typography>
          </Box>
          <Box display={"flex"} gap={0.5} flexDirection={"column"} ml={3}>
            {entityData?.paloalto_cortex_xdr_data?.local_users?.length > 0 &&
              entityData.paloalto_cortex_xdr_data.local_users.map(
                (localUser) => (
                  <TextIntegrationStyle
                    key={localUser}
                    title={
                      <Box display={"flex"} gap={1}>
                        <IntegrationImage
                          name={"paloalto_cortex_xdr"}
                          width={"16px"}
                          newLogo={true}
                        />
                      </Box>
                    }
                    value={localUser}
                  />
                )
              )}
            {entityData?.qualys_data?.local_admin_users?.length > 0 &&
              entityData.qualys_data.local_admin_users.map((localUser) => (
                <TextIntegrationStyle
                  key={localUser}
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={"qualys"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={localUser}
                />
              ))}
          </Box>
        </Box>
      )}
      {entityData?.paloalto_cortex_xdr_data?.isolation_status && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Isolation Status</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"paloalto_cortex_xdr"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.paloalto_cortex_xdr_data?.isolation_status}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.most_frequent_user && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Most Frequent User</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.most_frequent_user}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.responsible_group && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Responsible Group</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.responsible_group}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.company && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Company</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.company}
            />
          </Box>
        </Box>
      )}
      {(entityData?.microsoft_sccm_data?.user_account_control_flags?.length >
        0 ||
        entityData?.microsoft_active_directory_data?.user_account_control_flags
          ?.length > 0) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>AD Account Options</Typography>
          </Box>
          <Box display={"flex"} gap={1} ml={3} flexDirection={"column"}>
            {entityData?.microsoft_sccm_data?.user_account_control_flags?.map(
              (flag, index) => (
                <TextIntegrationStyle
                  key={`sccm-uac-flag-${index}`}
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"microsoft_sccm"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={AD_ACCOUNT_OPTIONS_DISPLAY_NAMES[flag] || flag}
                />
              )
            )}
            {entityData?.microsoft_active_directory_data?.user_account_control_flags?.map(
              (flag, index) => (
                <TextIntegrationStyle
                  key={`ad-uac-flag-${index}`}
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"microsoft_active_directory"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={AD_ACCOUNT_OPTIONS_DISPLAY_NAMES[flag] || flag}
                />
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_data?.allowed_to_delegate_to
        ?.length > 0 && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>
              Constrained Delegation Service
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={2}>
            {entityData?.microsoft_active_directory_data?.allowed_to_delegate_to?.map(
              (item, idx) => (
                <TextIntegrationStyle key={idx} title={""} value={item} />
              )
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ServerDetailsView;
